module.exports = __webpack_public_path__ + "img/logo.fd80b875.png";